import React, { useState, useEffect } from "react";
import { Card, Table } from "react-bootstrap";
import { apiService } from "service/ApiService";
import { notificationService } from "service/NotificationService";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function DocumentLinesTable({ modalOpen, docId }) {
  const {
    t,
  } = useTranslation();

  const [data, setData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);

  const getData = async () => {
    setShowLoader(true);
    try {
      const dataResponse = await apiService.get(`api/v1/document-lines/document/${docId}`);
      setData(dataResponse);
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    if (!docId) return;
    if (modalOpen && docId) getData();
  }, [docId]);

  return (
    <Card className="regular-table-with-color">
      <Card.Body className="table-responsive p-0">
        {showLoader ? (
          <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
            <ClipLoader size={50} color={"#ff6fbc"} />
          </div>
        ) : (
          <Table className="table-hover">
            <thead>
              <tr>
                <th>ID</th>
                <th>{t("tables.headers.product")}</th>
                <th>{t("tables.headers.qty")}</th>
                <th>{t("tables.headers.openingEuro")}</th>
                <th>{t("tables.headers.discountEuro")}</th>
                <th>{t("tables.headers.totalEuro")}</th>
                <th>{t("tables.headers.netValueEuro")}</th>
                <th>{t("tables.headers.vatEuro")}</th>
                <th>{t("tables.headers.vatPercent")}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row) => (
                <tr key={row.localId} className={row.className}>
                  <td>{row.localId}</td>
                  <td>{row.comment}</td>
                  <td>{row.quantity}</td>
                  <td>{row.subtotal.toFixed(2)}</td>
                  <td>{row.discount.toFixed(2)}</td>
                  <td>{row.total.toFixed(2)}</td>
                  <td>{row.net.toFixed(2)}</td>
                  <td>{row.vatAmount.toFixed(2)}</td>
                  <td>{row.vat.percent}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
}

export default DocumentLinesTable;
